
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"585","height":"1024"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.423 1002.576c-28.564-28.562-28.564-74.876 0-103.439l387.138-387.138L21.423 124.862c-28.564-28.564-28.564-74.876 0-103.44s74.875-28.564 103.44 0L563.72 460.279c28.564 28.564 28.564 74.876 0 103.44l-438.857 438.856c-28.564 28.562-74.876 28.562-103.44 0z"}})])
          )
        }
      }
    